// extracted by css-extract-rspack-plugin
export default {"marqueeTopBorder":"IntroSection-module__marqueeTopBorder__W_hmG","pillarsWithCopilot":"IntroSection-module__pillarsWithCopilot__FKBJB"};